import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidFlashNumber } from '../../../../mechanics/rid-flash-number/rid-flash-number';

@Component({
  selector: 'app-flash-number-page',
  imports: [RidFlashNumber],
  templateUrl: './flash-number-page.html',
})
export class FlashNumberPage {
  protected readonly $router = inject(Router);
}
